import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="玩法说明" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        在 6 次机会内猜出目标日麻和牌牌型。
        <br />
        每次提交后，牌面的颜色会提示你的猜测和目标手牌的接近程度。
      </p>

      <p className="text-sm text-green-700 dark:text-green-500">
        提交的手牌必须是有效和牌。
        <br />
        建议按 m/p/s/z、1-9 的顺序输入，便于对照题面。
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="🀇" />
        <Cell value="🀈" />
        <Cell value="🀉" />
        <Cell value="🀜" />
        <Cell value="🀝" />
        <Cell value="🀞" />
        <Cell value="🀔" />
        <Cell value="🀖" />
        <Cell value="🀗" status="correct" />
        <Cell value="🀘" />
        <Cell value="🀅" />
        <Cell value="🀅" />
        <Cell value="🀅" />
        <Cell value="🀔" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        蓝色表示这张牌存在，并且位置正确。
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="🀇" />
        <Cell value="🀈" />
        <Cell value="🀉" />
        <Cell value="🀜" />
        <Cell value="🀝" status="present" />
        <Cell value="🀞" />
        <Cell value="🀔" />
        <Cell value="🀖" />
        <Cell value="🀗" />
        <Cell value="🀘" />
        <Cell value="🀅" />
        <Cell value="🀅" />
        <Cell value="🀅" />
        <Cell value="🀔" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        橙色表示这张牌存在，但位置不正确。
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="🀇" />
        <Cell value="🀈" />
        <Cell value="🀉" />
        <Cell value="🀜" />
        <Cell value="🀝" />
        <Cell value="🀞" />
        <Cell value="🀔" />
        <Cell value="🀖" />
        <Cell value="🀗" />
        <Cell value="🀘" />
        <Cell value="🀅" status="absent" />
        <Cell value="🀅" status="absent" />
        <Cell value="🀅" status="absent" />
        <Cell value="🀔" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        灰色表示这张牌不在目标手牌中。
      </p>

      <p className="text-sm text-gray-500 dark:text-gray-300">
        也可以用键盘快速输入。比如输入{' '}
        <span className="font-mono">123m456p5789s666z5s</span>
        {' '}会转换成对应牌面。
      </p>

      <div className="mt-6 border-t border-gray-200 pt-4 text-center dark:border-gray-700">
        <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
          玩得开心的话，可以请我喝杯咖啡
        </p>
        <img
          src="/wechat-pay.png"
          alt="微信收款码"
          className="mx-auto mt-3 h-auto w-72 max-w-full rounded border border-gray-200 dark:border-gray-700 sm:w-80"
        />
      </div>
    </BaseModal>
  )
}
